import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

interface SettingsRowProps {
  label: string;
  children: React.ReactNode;
  action?: React.ReactNode;
  first?: boolean;
}

// label | value | action, separated from the row above by a hairline. Label and value stack on very narrow widths.
const SettingsRow: React.FC<SettingsRowProps> = ({ label, children, action, first = false }) => {
  const { palette } = useTheme();
  return (
    <Box
      sx={{
        display: 'flex', alignItems: 'center', columnGap: 1.5, rowGap: 0.25, flexWrap: 'wrap', py: 1.75,
        borderTop: first ? 'none' : `1px solid ${palette.tokens.hairlineSoft}`,
      }}
    >
      <Typography sx={{ width: 120, flexShrink: 0, fontSize: '14px', color: palette.tokens.muted, '@media (max-width:360px)': { width: '100%' } }}>
        {label}
      </Typography>
      <Box sx={{ flex: 1, minWidth: 0 }}>{children}</Box>
      {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
    </Box>
  );
};

export default SettingsRow;
